const expr = /([a-zA-Z0-9.+-]+@[a-zA-Z0-9.-]+.[a-zA-Z0-9._-]+)/;

// detect email address
const includesEmailAddress = (str: string) => expr.test(str);

export default includesEmailAddress;
